export default __webpack_public_path__ + "static/media/Billing History (1).59ed4d89.svg";